import Mutation from '@/components/AIChat/store/mutationTypes';
import { getLocalLanguage } from "@/plugins/i18n";
const addChatSideEffects = store => {
    store.subscribe((mutation) => {
        if (mutation.type === ("aichat/" + Mutation.SET_ADD_CHAT_MESSAGE)) {
            setTimeout(function() { $(".cb-chatarea").scrollTop($(".cb-chatarea")[0].scrollHeight) ; }, 200);
        }
        if (mutation.type === ("aichat/" + Mutation.SET_ITEM) && mutation.payload.field == 'waitingReply') {
            if($(".cb-chatarea") && $(".cb-chatarea").length > 0) {
                setTimeout(function() { $(".cb-chatarea").scrollTop($(".cb-chatarea")[0].scrollHeight) ; }, 200);
            }
        }
        if (mutation.type === ("aichat/" + Mutation.SET_ITEM)) {
            if( mutation.payload.field == 'userMessage') {
                //give some time to set the message in textarea, before we calculate the height
                setTimeout(function() { 
                    $("textarea#usermessage").height(22);
                    if(mutation.payload.value!='') {
                        $("textarea#usermessage").height($("#usermessage").prop('scrollHeight')+2);
                    }
                },20);
            }
            if(mutation.payload.field == 'waitingReply' && mutation.payload.value==false) {
                setTimeout(function() { $("textarea#usermessage").focus();},20);
            }
            
            //select the default language if the wizard step is language-selection
            if(mutation.payload.field == 'wizardStep' && mutation.payload.value=='language-selection') {
                const selectedVersionId = store.getters['aichat/getItem']('versionId');
                if(selectedVersionId) {
                    const selectedVersion = store.getters['aichat/getItem']('versions')[selectedVersionId];
                    const selectedVersionLangs = selectedVersion.lang;
                    const localLanguage = getLocalLanguage().trim().toLowerCase();
                    for(let i=0; i < selectedVersionLangs.length; i++) {
                        let pdfItem = selectedVersionLangs[i];
                        if(pdfItem.language.trim().toLowerCase() == localLanguage) {
                            store.commit("aichat/" + Mutation.SET_ITEM, { field: 'itemId', value: pdfItem.uid });
                            store.commit("aichat/" + Mutation.SET_ITEM, { field: 'resId', value: pdfItem.res_id });
                            store.commit("aichat/" + Mutation.SET_ITEM, { field: 'pubId', value: pdfItem.pub_id });
                            break;
                        }
                    }
                }
            }
        }
        
    });
}

export default [
    addChatSideEffects
];